export default __webpack_public_path__ + "static/media/decorator.c20448e4.svg";